import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getUserProfile} from "../../../store/rootReducer";
import './AccountDropdownToggle.scss'
import ActionLink from "../../link/ActionLink";
import AccountDropdown from "./AccountDropdown";
import ClickableDiv from "../../button/ClickableDiv";

class AccountDropdownToggle extends Component {

  constructor(props) {
    super(props);
    this.isIE = navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > -1

    this.state = {
      showDropdown: false
    };
  }

  toggleDropdown = () => {
    this.setState({
      showDropdown: !this.state.showDropdown
    });
  };

  // In React, the onBlur functionality does not actually work as expected. While tabbing through child elements inside a parent,
  // everytime we tab, the onBlur moves outside of the parent, then back into the next element. This does not work for our purpose,
  // since we want to keep the dropdown open as long as the tab focus is inside the dropdown. The below function, overrides the
  // standard onBlur functionality and checks to see if the current node we are moving to is still inside the parent
  // From StackOverflow: https://stackoverflow.com/a/38019906/4215097
  checkFocusInsideDropdown = ({relatedTarget, currentTarget}) => {
    if (relatedTarget === null) return false;
    let node = relatedTarget.parentNode;

    while (node !== null) {
      if (node === currentTarget) return true;
      node = node.parentNode;
    }
    return false;
  };

  dropDownItemSelected = () => {
    this.setState({
      showDropdown: false
    });
  }

  onBlur = (e) => {
    if (!this.isIE && !this.checkFocusInsideDropdown(e)) {
      this.setState({
        showDropdown: false
      });
    }
  };

  render() {
      return (
        <div onBlur={this.onBlur}>
          <ClickableDiv className="account-dropdown-toggle" onClick={this.toggleDropdown}>
            <i className="la la-user"/>
            <ActionLink text="navbar.account"/>
          </ClickableDiv>
          {this.state.showDropdown &&
          <AccountDropdown {...this.props} dropDownItemSelected={this.dropDownItemSelected} />
          }
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userProfile: getUserProfile(state)
  }
};

export default connect(mapStateToProps)(AccountDropdownToggle);